<template>
  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 mt-2">
    <label>{{ text }}</label>
  </div>
</template>

<script>
export default {
  name: 'FormLabel',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>
